import React, { useState, useEffect } from "react";
import AuctionItem from "../components/AuctionItem";
import ProductItem from "../components/ProductItem";
import { useNavigate } from "react-router-dom";
import "../styles/ForYou.css";
import { db } from "../utils/firebaseconfig";
import { collection, getDocs } from "firebase/firestore";

function ForYou() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchItems = async () => {
      setIsLoading(true);
      try {
        const productsSnapshot = await getDocs(collection(db, "Product"));
        const auctionsSnapshot = await getDocs(collection(db, "Auction"));

        const products = productsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          isAuction: false,
          image: doc.data().images?.[0] || "https://via.placeholder.com/300",
        }));

        const auctions = auctionsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          isAuction: true,
          image: doc.data().images?.[0] || "https://via.placeholder.com/300",
        }));

        // Improved random shuffling using Fisher-Yates algorithm
        const shuffleArray = (array) => {
          for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
          }
          return array;
        };

        const combined = shuffleArray([...products, ...auctions]);
        setItems(combined);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchItems();
  }, []);

  const handleGetProduct = (item) => {
    navigate(`/product/${item.id}`, { state: { product: item } });
  };

  const handleScroll = (event) => {
    if (event.deltaY > 0) {
      setCurrentIndex((prev) => Math.min(prev + 1, items.length - 1));
    } else {
      setCurrentIndex((prev) => Math.max(prev - 1, 0));
    }
  };

  let touchStartY = 0;
  let touchEndY = 0;

  const handleTouchStart = (event) => {
    touchStartY = event.touches[0].clientY;
  };

  const handleTouchMove = (event) => {
    touchEndY = event.touches[0].clientY;
  };

  const handleTouchEnd = () => {
    if (touchStartY - touchEndY > 50) {
      setCurrentIndex((prev) => Math.min(prev + 1, items.length - 1));
    } else if (touchEndY - touchStartY > 50) {
      setCurrentIndex((prev) => Math.max(prev - 1, 0));
    }
  };

  const handleKeyNavigation = (event) => {
    if (event.key === "ArrowUp") {
      setCurrentIndex((prev) => Math.max(prev - 1, 0));
    } else if (event.key === "ArrowDown") {
      setCurrentIndex((prev) => Math.min(prev + 1, items.length - 1));
    }
  };

  useEffect(() => {
    window.addEventListener("wheel", handleScroll);
    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("touchend", handleTouchEnd);
    window.addEventListener("keydown", handleKeyNavigation);

    return () => {
      window.removeEventListener("wheel", handleScroll);
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
      window.removeEventListener("keydown", handleKeyNavigation);
    };
  }, [items]);

  if (isLoading) {
    return (
      <div className="app">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Finding amazing items for you...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="app__items">
        {items.length > 0 ? (
          items.map((item, index) => (
            <div
              key={item.id}
              className={`forYou-slide ${index === currentIndex ? "active" : "hidden"}`}
              onClick={() => handleGetProduct(item)}
            >
              {item.isAuction ? (
                <AuctionItem
                  title={item.title}
                  image={item.image}
                  currentBid={item.currentBid}
                  auctioneer={item.auctioneer}
                  isForYou={true}
                />
              ) : (
                <ProductItem
                  title={item.title || item.name}
                  image={item.image}
                  price={item.price}
                  rating={item.rating || 0}
                  description={item.description}
                  seller={item.seller || item.ownerName}
                  isForYou={true}
                />
              )}
            </div>
          ))
        ) : (
          <div className="no-items">
            <p>No items available at the moment</p>
            <p>Please check back later!</p>
          </div>
        )}
      </div>
      <div className="navigation-indicators">
        <div className="current-position">
          {items.length > 0 && `${currentIndex + 1} / ${items.length}`}
        </div>
      </div>
      <div className="swipe-indicator">
        <i className="fas fa-arrow-up"></i>
        Swipe or use arrow keys to navigate
      </div>
    </div>
  );
}

export default ForYou;
